import { Link } from 'react-router-dom'
import { MessageSquare, Clock } from 'lucide-react'
import { formatDistanceToNow } from 'date-fns'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { ChatSession, UserChatMessage } from '@/types'
import { safeParseDate } from '@/lib/date-utils'

interface SessionHistoryItemProps {
  session: ChatSession
}

export const SessionHistoryItem = ({ session }: SessionHistoryItemProps) => {
  const firstUserMessage = session.messages.find(
    (msg): msg is UserChatMessage => msg.role === 'user',
  )
  const lastInteractionDate = safeParseDate(session.last_interaction)

  return (
    <Link to={`/session/${session.id}`}>
      <Card className="hover:border-primary hover:bg-accent transition-colors">
        <CardHeader>
          <CardTitle className="text-base font-semibold truncate flex items-center gap-2">
            <MessageSquare className="h-5 w-5 text-primary flex-shrink-0" />
            <span className="truncate">
              {firstUserMessage?.content || 'Untitled Session'}
            </span>
          </CardTitle>
          <CardDescription className="font-mono text-xs">
            {session.id}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="flex items-center text-xs text-muted-foreground">
            <Clock className="mr-1.5 h-3 w-3" />
            {lastInteractionDate
              ? `Last activity ${formatDistanceToNow(lastInteractionDate, { addSuffix: true })}`
              : 'No activity date'}
          </div>
        </CardContent>
      </Card>
    </Link>
  )
}
